import { getGalleryModel, getReviewsModel, mapPropertySearchResults, SearchMigrationAdapter } from 'src/common/stores/adapters/bex-api';

import { GalleryViewModel, HotelResultsViewModel, HotelViewModel, ReviewsViewModel } from 'models';

import { OperationResult } from '__generated__/api/api-operations';
import { PropertyMapMigration } from '__generated__/api';

export const adaptProperties: SearchMigrationAdapter = (
  bffResults: HotelResultsViewModel,
  bexApiResults: OperationResult<PropertyMapMigration.Query>
): HotelResultsViewModel => {
  const { data } = bexApiResults;
  const { propertySearch } = data;

  if (!propertySearch || !propertySearch.properties) {
    return bffResults;
  }

  return {
    ...bffResults,
    hotels: mapPropertySearchResults(data)
  };
};

// Wave 1 is property review summary
export const adaptPropertiesWave1: SearchMigrationAdapter = (
  bffResults: HotelResultsViewModel,
  bexApiResults: OperationResult<PropertyMapMigration.Query>,
  bexApiPropertyDict: { [key: string]: PropertyMapMigration.Properties }
): HotelResultsViewModel => adaptPropertyField(bffResults, bexApiResults, getReviews, bexApiPropertyDict);

const getReviews = (property: PropertyMapMigration.Properties, bffHotel: HotelViewModel): { reviews: ReviewsViewModel } => ({
  reviews: property && property.reviews ? getReviewsModel(property.reviews) : bffHotel.reviews
});

// Wave 2 is the property gallery
export const adaptPropertiesWave2: SearchMigrationAdapter = (
  bffResults: HotelResultsViewModel,
  bexApiResults: OperationResult<PropertyMapMigration.Query>,
  bexApiPropertyDict: { [key: string]: PropertyMapMigration.Properties }
): HotelResultsViewModel => adaptPropertyField(bffResults, bexApiResults, getGallery, bexApiPropertyDict);

const getGallery = (property: PropertyMapMigration.Properties, bffHotel: HotelViewModel): { gallery: GalleryViewModel } => ({
  gallery: property && property.propertyGallery ? getGalleryModel(property.propertyGallery) : bffHotel.gallery
});

const adaptPropertyField = <T extends keyof HotelViewModel>(
  bffResults: HotelResultsViewModel,
  bexApiResults: OperationResult<PropertyMapMigration.Query>,
  fieldToMigrate: (bex: PropertyMapMigration.Properties, bff: HotelViewModel) => HotelViewModel[T],
  bexApiPropertyDict: { [key: string]: PropertyMapMigration.Properties }
): HotelResultsViewModel => {
  const { data } = bexApiResults;
  const { propertySearch } = data;

  if (!propertySearch || !propertySearch.properties) {
    return bffResults;
  }

  const hotels = bffResults.hotels.map(hotel => {
    const bexApiHotel = bexApiPropertyDict[String(hotel.id)];

    const field = fieldToMigrate(bexApiHotel, hotel);

    return {
      ...hotel,
      ...field
    };
  });

  return {
    ...bffResults,
    hotels
  };
};
